export default __webpack_public_path__ + "static/media/tokens.0b100ceb.svg";